import {CartMixin} from '../../../Mixins';
import {Component, Prop, Watch} from 'vue-property-decorator';
import {TicketConfiguration} from '../../../Models';
import {getDateString, ProductQuantityUtility} from '../../../Utilities';
import {mixins} from 'vue-class-component';
import Trash from '../../Icons/Trash.vue';
import InfoButton from '../../Components/InfoButton/InfoButton.vue';
import {AdditionalOrderItemConfiguration} from '../../../Models/AdditionalOrderItemConfiguration';
import {AdditionalOrderItemConfigurationDTO} from '../../../DTOs/AdditionalOrderItemConfigurationDTO';
import Vvs from '../../Icons/Vvs.vue';
import {DEFAULT_LANGUAGE} from '../../../constants';
@Component({
  components: {
    InfoButton,
    Trash,
    CartItem,
    Vvs,
  },
})
export default class CartItem extends mixins(CartMixin) {
  @Prop({required: true, type: Object}) ticketConfiguration!: TicketConfiguration | undefined;
  @Prop({default: false, type: Boolean}) readonly!: boolean;

  @Watch('ticketConfiguration.quantity')
  onTicketConfigurationQuantityChange(newVal: number) {
    if (newVal && this.ticketConfiguration) {
      if (this.ticketConfiguration.product.maxOrderQuantity) {
        if (this.currentTotalOfProduct - this.diffBetweenConfigAndOrder > this.ticketConfiguration.product.maxOrderQuantity) {
          const maxPossibleVal = this.ticketConfiguration.product.maxOrderQuantity - (this.currentTotalOfProduct - this.orderQuantity);
          this.$emit('setQuantity', this.ticketConfiguration, maxPossibleVal);
        }
      }
      if (newVal < this.ticketConfiguration.product.minOrderQuantity) {
        let nextVal = newVal;
        if (!this.reachedMinPositionQuantity) {
          nextVal = this.orderQuantity;
        }
        this.$emit('setQuantity', this.ticketConfiguration, nextVal);
      }
    }
  }

  decrementQuantity(): void {
    if (this.ticketConfiguration) {
      this.$emit('setQuantity', this.ticketConfiguration, this.ticketConfiguration.quantity - 1);
      this.emitUpdateCart();
    }
  }

  incrementQuantity(): void {
    if (this.ticketConfiguration) {
      this.$emit('setQuantity', this.ticketConfiguration, this.ticketConfiguration.quantity + 1);
      this.emitUpdateCart();
    }
  }

  emitUpdateCart() {
    this.$emit('updateCart');
  }

  subTicketDisplayQuantity(ticketConfiguration: TicketConfiguration): number {
    if (this.checkoutView) {
      return ticketConfiguration.quantity;
    }
    return ticketConfiguration.product.maxOrderQuantity || ticketConfiguration.product.minOrderQuantity;
  }

  get VVSInformation() {
    const aoic = this.additionalOrderItemInformation;
    if (aoic?.publicTransportConfig?.usePubTrans) {
      return `${getDateString(
        this.userLanguage,
        new Date(<string>aoic.publicTransportConfig.selectedDate,
        ))} ${aoic.publicTransportConfig.passengerName} ${aoic.publicTransportConfig.passengerSurname}`;
    }

    return this.$t('checkout.check.noVVSSelected');
  }

  get additionalOrderItemInformation(): AdditionalOrderItemConfigurationDTO | null {
    let aoic = this.orderDTO.additionalOrderItemConfigurations.find(a => this.ticketConfiguration!.id === a.id);
    if (aoic) {
      return aoic;
    }
    aoic = this.orderDTO.additionalOrderItemConfigurations.find(a => this.ticketConfiguration!.id === a.orderItemId);
    if (aoic) {
      return aoic;
    }
    return null;
  }

  get isPromotedBy1NCode() {
    return this.ticketConfiguration
      && this.ticketConfiguration.isPromoted
      && this.ticketConfiguration.promotion
      && this.ticketConfiguration.promotion.promotionCodeType === 1;
  }

  get client() {
    if (this.ticketConfiguration && this.ticketConfiguration.event) {
      return this.getClient(this.ticketConfiguration.event.clientId);
    }
    return null;
  }

  get productPromotion() {
    if (this.ticketConfiguration && this.ticketConfiguration.isPromoted && this.ticketConfiguration.promotion) {
      return this.ticketConfiguration.promotion;
    }
    return null;
  }

  get isSubProduct() {
    return this.ticketConfiguration ? this.ticketConfiguration.isSubProduct : false;
  }

  // get showUpdateAction() {
  // return !this.checkoutView
  //     && this.ticketConfiguration
  //     && !this.ticketConfiguration.specialProduct
  //     && this.ticketConfiguration.quantity !== this.ticketConfiguration.initialQuantity
  //     && this.reachedMinPositionQuantity;
  // }

  get hideQuantityControls() {
    return this.checkoutView
      || this.readonly
      || (
        this.ticketConfiguration !== undefined
        && this.ticketConfiguration.product.minOrderQuantity === this.ticketConfiguration.product.maxOrderQuantity
      )
      || (
        this.disableIncrease && this.disableDecrease
      );
  }

  get disableDecrease(): boolean {
    if (this.ticketConfiguration) {
      return this.ticketConfiguration.quantity === 0 || this.hasMinPositionQuantity;
    }
    return true;
  }

  get disableIncrease(): boolean {
    if (this.ticketConfiguration) {
      return (this.ticketConfiguration.subTicketConfigurations.length > 0 && this.ticketConfiguration.quantity === 1)
        || this.reachedMaxPositionQuantity
        || (!this.ticketConfiguration.isSubProduct && this.reachedMaxOrderQuantity);
    }
    return true;
  }

  get reachedMaxPositionQuantity(): boolean {
    if (this.ticketConfiguration) {
      return (new ProductQuantityUtility(this.currentOrder))
        .cartReachedMaxPositionQuantity(this.ticketConfiguration);
    }
    return false;
  }

  get reachedMinPositionQuantity() {
    if (this.ticketConfiguration) {
      return (new ProductQuantityUtility(this.currentOrder))
        .cartReachedMinPositionQuantity(this.ticketConfiguration);
    }
    return false;
  }

  get hasMinPositionQuantity() {
    if (this.ticketConfiguration) {
      return (new ProductQuantityUtility(this.currentOrder))
        .cartHasMinPositionQuantity(this.ticketConfiguration);
    }
    return false;
  }

  get reachedMaxOrderQuantity(): boolean {
    if (this.ticketConfiguration) {
      return (new ProductQuantityUtility(this.currentOrder))
        .cartReachedMaxOrderQuantity(this.ticketConfiguration);
    }
    return false;
  }

  get currentTotalOfProduct(): number {
    if (this.ticketConfiguration) {
      const product = this.ticketConfiguration.product;
      return (new ProductQuantityUtility(this.currentOrder))
        .currentTotalOfProduct(product);
    }
    return 0;
  }

  get diffBetweenConfigAndOrder(): number {
    if (this.ticketConfiguration) {
      return (new ProductQuantityUtility(this.currentOrder))
        .getDiffBetweenConfigAndOrder(this.ticketConfiguration);
    }
    return 0;
  }

  /**
   * Return the unmodified quantity in the order items, not the editable on in the ticket configs
   */
  get orderQuantity(): number {
    if (this.currentOrder && this.ticketConfiguration) {
      return (new ProductQuantityUtility(this.currentOrder))
        .getOrderQuantity(this.ticketConfiguration);
    }
    return 0;
  }

  get productInfoText(): string {
    const product = this.ticketConfiguration?.product;
    if (product?.infoButtonText) {
      if (this.userLanguage !== DEFAULT_LANGUAGE) {
        const translations = product.infoButtonText.translations;

        if (translations && this.userLanguage in translations) {
          return translations[this.userLanguage].text || '';
        }
      }
      return product.infoButtonText?.text || '';
    }

    return '';
  }
}
